import { Quill } from 'react-quill';
const Break = Quill.import('blots/break');

class LineBreakBlot extends Break {
  length() {
    return 1;
  }
  value() {
    return '\n';
  }
  insertInto(parent: any, ref: any) {
    Quill.import('blots/embed').prototype.insertInto.call(this, parent, ref);
  }
}

LineBreakBlot.blotName = 'line-break';
LineBreakBlot.tagName = 'BR';

Quill.register('formats/line-break', LineBreakBlot);
